import React from 'react';
import { ProtectedContainerProps, getPages as getPagesCore } from 'omni-package-react-core';
import Constants from '../../Constants';

const getPages = (
  ProtectedContainer: React.FC<ProtectedContainerProps>,
  isAuthenticated: boolean,
) => getPagesCore([], ProtectedContainer, isAuthenticated, Constants.BasePageSegment);

export default getPages;
